import React, { useContext, useState, useRef, useEffect } from "react";
import ContextApi from "../../context/ContextApi";
import "../../stylesheet/forms.css";
import Allergy from "./utils/AllergyOptions";
import HereditaryOptions from "./utils/HereditaryOptions";


export default function PatientMedicalHistory(props) {
  const {
    hospitalized,
    setHostpitalized,
    setIDoctorCare,
    medication,
    doctorcare,
    setMedication,
    gainedWeight,
    setGainedWeight,
    pregnant,
    setPregnant,
    smoker,
    drinker,
    allergies,
    setAllergies,
    hereditary,
    sethereditary,
    setSmoker,
    setDrinker,
    preExistingCondition,
    setPreExistingCondition,
    // medHistoryData, setMedHistoryData
  } = useContext(ContextApi);


  const ref = useRef(null);

  const [textareaVisibility, setTextareaVisibility] = useState({
    question1: { status: false, answer: '' },
    question2: { status: false, answer: '' },
    question3: { status: false, answer: '' },
    question4: { status: false, answer: '' },
    question5: { status: false, answer: '' },
    question6: { status: false, answer: '' },
    question7: { status: false, answer: '' },
    question8: { status: false, answer: '' },
    question9: { status: false, answer: '' },
  });

  const [checkboxareaVisibility, setCheckboxareaVisibility] = useState({
    question1: false,
    question2: false,
    question3: false,
  });

  useEffect(() => {
    if (localStorage.getItem('patientEditMode') === 'true') {
      setTextareaVisibility({
        ...textareaVisibility,
        question1: { status: hospitalized && true, answer: `${hospitalized}` },
        question2: { status: doctorcare && true, answer: `${doctorcare}` },
        question3: { status: medication && true, answer: `${medication}` },
        question5: { status: drinker && true, answer: `${drinker}` },
        question7: { status: gainedWeight && true, answer: `${gainedWeight}` },
        question8: { status: pregnant && true, answer: `${pregnant}` },
        question6: { status: smoker && true, answer: `${smoker}` },
      });
      setCheckboxareaVisibility({
        ...checkboxareaVisibility,
        question1: allergies.length && true,
        question2: hereditary.length && true,
        question3: preExistingCondition.length && true
      })
    }
  }, [hospitalized,
    medication,
    doctorcare,
    gainedWeight,
    pregnant,
    smoker,
    drinker,
    allergies,
    hereditary, preExistingCondition])
  const handleShowTextarea = (questionId, event) => {
    setTextareaVisibility({
      ...textareaVisibility,
      [questionId]: { status: event, answer: '' },
    });
  };

  const handleShowCheckboxarea = (questionId, status) => {
    setCheckboxareaVisibility({
      ...checkboxareaVisibility,
      [questionId]: status
    });
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault()
    props.onContinue()
  }

  return (
    <div className="font-euclid-circular-a">
      <div className="overflow-auto border border-gray-400 rounded-2xl w-full lg:w-[750px] lg:h-[600px] mb-5 lg:ml-[5%] mt-5 p-3 summary-steps">
        <h1 className="text-xl font-bold lg:ml-3 mt-4 text-gray-600">
          Medical History
        </h1>

        <div className="mt-8 overflow-auto">
          <form id="form_hospital" className="lg:pl-9 lg:pr-9">
            <div className="flex flex-col">
              <label htmlFor="Hospitalized" className="mb-2">
                Hospitalized, operated on, or serious illness in the past 3
                years?
              </label>
              <div>
                <label htmlFor="hospitalized" >Yes </label>
                <input type="radio"
                  id="hospitalized"
                  name="question1"
                  value="true"
                  checked={textareaVisibility.question1.status}
                  onChange={() => handleShowTextarea("question1", true)}
                />
                <label className="ml-3" htmlFor="not-hospitalized" > No </label>
                <input type="radio"
                  id="not-hospitalized"
                  name="question1"
                  value="false"
                  checked={!textareaVisibility.question1.status}
                  onChange={() => {
                    handleShowTextarea("question1", false);
                    setHostpitalized('')
                  }}
                />
              </div>

              {textareaVisibility.question1.status && (
                <textarea
                  onInput={(e) => setHostpitalized(e.target.value)}
                  defaultValue={hospitalized}
                  name=""
                  id="1"
                  cols="30"
                  rows="5"
                  placeholder="Enter more details..."
                  className="border mt-3 rounded p-3"
                />

              )}
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="question2" className="mb-2">
                Under doctor’s care in the past 3 years?
              </label>

              <div>
                <label htmlFor="doctorscare" >Yes </label>
                <input type="radio"
                  id="doctorscare"
                  name="question2"
                  value="true"
                  checked={textareaVisibility.question2.status}
                  onChange={() => handleShowTextarea("question2", true)}
                />
                <label className="ml-3" htmlFor="not-doctorscare" > No </label>
                <input type="radio"
                  id="not-doctorscare"
                  name="question2"
                  value="false"
                  checked={!textareaVisibility.question2.status}
                  onChange={() => {
                    handleShowTextarea("question2", false)
                    setIDoctorCare('')
                  }}
                />
              </div>
              {textareaVisibility.question2.status && (
                <textarea
                  onInput={(e) => setIDoctorCare(e.target.value)}
                  defaultValue={doctorcare}
                  name=""
                  id="2"
                  cols="30"
                  rows="5"
                  placeholder="Enter more details..."
                  className="border mt-3 rounded p-3"
                />
              )}
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="question3" className="mb-2">
                Administered medication in the past 6 months?
              </label>

              <div>
                <label htmlFor="medication" >Yes </label>
                <input type="radio"
                  id="medication"
                  name="question3"
                  value="true"
                  checked={textareaVisibility.question3.status}
                  onChange={() => handleShowTextarea("question3", true)}
                />
                <label className="ml-3" htmlFor="not-medication" > No </label>
                <input type="radio"
                  id="not-medication"
                  name="question3"
                  value="false"
                  checked={!textareaVisibility.question3.status}
                  onChange={() => {
                    handleShowTextarea("question3", false);
                    setMedication('')
                  }}
                />
              </div>

              {textareaVisibility.question3.status && (
                <textarea
                  onInput={(e) => setMedication(e.target.value)}
                  defaultValue={medication}
                  name=""
                  id="3"
                  cols="30"
                  rows="5"
                  placeholder="Enter more details..."
                  className="border mt-3 rounded p-3"
                />
              )}
            </div>

            <div className="flex flex-col mt-4">
              <div className="">
                <label htmlFor="question4" className="mb-2">
                  Any allergies?
                </label>
                <div className="">
                  <label htmlFor="allergy" >Yes </label>
                  <input type="radio"
                    id="allergy"
                    name="allergy"
                    value="true"
                    checked={checkboxareaVisibility.question1}
                    onChange={() => handleShowCheckboxarea("question1", true)}
                  />
                  <label className="ml-3" htmlFor="not-allergy" > No </label>
                  <input type="radio"
                    id="not-allergy"
                    name="not-allergy"
                    value="false"
                    checked={!checkboxareaVisibility.question1}
                    onChange={() => {
                      handleShowCheckboxarea("question1", false)
                      setAllergies([])
                    }
                    }
                  />
                </div>
              </div>
              {
                checkboxareaVisibility.question1 && (
                  <Allergy ifAllergy={(newAllergies) => setAllergies(newAllergies.filter((item) => item.status))} selected={allergies} preSelected={allergies} />
                )
              }
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="question6" className="mb-2">
                Smoker?
              </label>
              <div>
                <label htmlFor="smoker" >Yes </label>
                <input type="radio"
                  id="smoker"
                  name="question6"
                  value="true"
                  checked={smoker}
                  onChange={() => setSmoker(true)}
                />
                <label className="ml-3" htmlFor="not-smoker" > No </label>
                <input type="radio"
                  id="not-smoker"
                  name="question6"
                  value="false"
                  checked={!smoker}
                  onChange={() => setSmoker(false)}
                />
              </div>
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="question5" className="mb-2">
                Drinker?
              </label>

              <div>
                <label htmlFor="drinker" >Yes </label>
                <input type="radio"
                  id="drinker"
                  name="question5"
                  value="true"
                  checked={textareaVisibility.question5.status}
                  onChange={() => handleShowTextarea('question5', true)}
                />
                <label className="ml-3" htmlFor="not-drinker" > No </label>
                <input type="radio"
                  id="not-drinker"
                  name="question5"
                  value="false"
                  checked={!textareaVisibility.question5.status}
                  onChange={() => {
                    handleShowTextarea('question5', false)
                    setDrinker('')
                  }}
                />
              </div>

              {textareaVisibility.question5.status && (
                <textarea
                  onInput={(e) => setDrinker(e.target.value)}
                  defaultValue={drinker}
                  name=""
                  id="drinker5"
                  cols="30"
                  rows="5"
                  placeholder="Enter more details..."
                  className="border mt-3 rounded p-3"
                />
              )}
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="question8" className="mb-2">
                Pregnant?
              </label>

              <div>
                <label htmlFor="pregnant" >Yes </label>
                <input type="radio"
                  id="pregnant"
                  name="question8"
                  value="true"
                  checked={textareaVisibility.question8.status}
                  onChange={() => {
                    handleShowTextarea('question8', true);
                    setPregnant('Yes')
                  }}
                />
                <label className="ml-3" htmlFor="not-pregnant" > No </label>
                <input type="radio"
                  id="not-pregnant"
                  name="question8"
                  value="false"
                  checked={!textareaVisibility.question8.status}
                  onChange={() => {
                    handleShowTextarea('question8', false);
                    setPregnant('')
                  }}
                />
              </div>

              {textareaVisibility.question8.status && (
                <textarea

                  onInput={(e) => setPregnant(e.target.value)}
                  defaultValue={pregnant}
                  name=""
                  id="6"
                  cols="30"
                  rows="5"
                  placeholder="Enter more details..."
                  className="border mt-3 rounded p-3"
                />
              )}
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="question7" className="mb-2">
                Gained or lost 10kg in the last 6 Months?
              </label>

              <div>
                <label htmlFor="weight" >Yes </label>
                <input type="radio"
                  id="weight"
                  name="question7"
                  value="true"
                  checked={textareaVisibility.question7.status}
                  onChange={() => handleShowTextarea('question7', true)}
                />
                <label className="ml-3" htmlFor="not-weight" > No </label>
                <input type="radio"
                  id="not-weight"
                  name="question7"
                  value="false"
                  checked={!textareaVisibility.question7.status}
                  onChange={() => {
                    handleShowTextarea('question7', false)
                    setGainedWeight('')
                  }}
                />
              </div>
              {textareaVisibility.question7.status && (
                <textarea
                  onInput={(e) => setGainedWeight(e.target.value)}
                  defaultValue={gainedWeight}
                  name=""
                  id="7"
                  cols="30"
                  rows="5"
                  placeholder="Enter more details..."
                  className="border mt-3 rounded p-3"
                />
              )}
            </div>

            <div className="flex flex-col mt-4">
              <div className="">
                <label htmlFor="question5" className="mb-2">
                  Any hereditary conditions?
                </label>
                <div className="">
                  <label htmlFor="hereditary" >Yes </label>
                  <input type="radio"
                    id="hereditary"
                    name="hereditary"
                    value="true"
                    checked={checkboxareaVisibility.question2}
                    onChange={() => {
                      handleShowCheckboxarea("question2", true)
                    }}
                  />
                  <label className="ml-3" htmlFor="not-hereditary" > No </label>
                  <input type="radio"
                    id="not-hereditary"
                    name="not-hereditary"
                    value="false"
                    checked={!checkboxareaVisibility.question2}
                    onChange={() => {
                      handleShowCheckboxarea("question2", false)
                      sethereditary([])
                    }
                    }
                  />
                </div>

              </div>

              {
                checkboxareaVisibility.question2 && (
                  <HereditaryOptions ifAllergy={(newHereditary) => sethereditary(newHereditary.filter((item) => item.status))} selected={checkboxareaVisibility.question2} preSelected={hereditary} />
                )
              }
            </div>
            <div className="flex flex-col mt-4">
              <div className="flex">
                <label htmlFor="question9" className="mb-2">
                  Pre-existing conditions?
                </label>

                <div className="ml-3">
                  <label htmlFor="existing" >Yes </label>
                  <input type="radio"
                    id="existing"
                    name="question9"
                    value="true"
                    checked={checkboxareaVisibility.question3}
                    onChange={() => handleShowCheckboxarea('question3', true)}
                  />
                  <label className="ml-3" htmlFor="not-existing" > No </label>
                  <input type="radio"
                    id="not-existing"
                    name="question9"
                    value="false"
                    checked={!checkboxareaVisibility.question3}
                    onChange={() => {
                      handleShowCheckboxarea('question3', false);
                      setPreExistingCondition([])
                    }}
                  />
                </div>
              </div>
              {
                checkboxareaVisibility.question3 && (
                  <HereditaryOptions ifAllergy={(newHereditary) => setPreExistingCondition(newHereditary.filter((item) => item.status))} selected={checkboxareaVisibility.question3}
                    preSelected={preExistingCondition} />
                )
              }

            </div>

            <div className="mt-3 flex justify-end w-full">
              <button
                className=" text-sky-600 border border-sky-600 mb-4 p-2 w-36 rounded ml-[250px]"
                onClick={props.onBack}
              >
                Back
              </button>
              <button
                className="bg-sky-600 text-white mb-4 p-2 w-36 rounded ml-3"
                onClick={handleFinalSubmit}
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
